export default function Home() {
  return (
    <div className="space-y-3 text-gray-300">
      <h1 className="text-2xl font-bold text-gray-100">
        Combat log analyzer
      </h1>
      <p className="max-w-prose">
        Analyzed reports live at their own private URL. If you have a link, paste
        it into your address bar to view a report. There is no public listing.
      </p>
    </div>
  );
}
